import { Search, WhatsApp } from "@mui/icons-material";
import '../../styles/ahbaab/ProductStyle.css';
import { Box, Button } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import Header from "../../common/ahbaab/Header/Header";
import Footer from "../../common/ahbaab/Footer/Footer";
import polygon from '../../assest/ahbaab/Cleanroom Products.jpg';
import OurProductData from "../../data/ahbaab/OurProductData";
import { FaSquareArrowUpRight } from "react-icons/fa6";

const Products = () => {
    const [showCount, setShowCount] = useState(8);
    const [showAll, setShowAll] = useState(false);
    const [activeSubFilter, setActiveSubFilter] = useState("all"); // "all" by default
    const [searchQuery, setSearchQuery] = useState("");
    const [isCategoryOpen, setIsCategoryOpen] = useState(true);

    const location = useLocation();
    const currentPath = location.pathname.split("/");
    const activeMainCategory = currentPath[2] || null;

    // Find the selected category object
    const selectedCategory = OurProductData.find(
        (item) => item.linkTag === activeMainCategory
    );

    // Search filter
    const filteredMainItems = OurProductData.filter(item =>
        item.heading.toLowerCase().includes(searchQuery)
    );

    const filteredCategoryItems = selectedCategory?.category?.filter(cat =>
        cat.categoryName.toLowerCase().includes(searchQuery)
    ) || [];

    // Handle search input
    const handleSearch = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
        setShowCount(8);
    };

    // Show more / less products
    const toggleImages = () => {
        const newShowCount = showCount + 8;
        setShowCount(newShowCount);

        const filteredLength = selectedCategory
            ? filteredCategoryItems.length
            : filteredMainItems.length;

        if (newShowCount >= filteredLength) {
            setShowAll(true);
        } else {
            setShowAll(false);
        }
    };

    // Filter products based on active sub filter
    const getDisplayedProducts = () => {
        if (!selectedCategory) return filteredMainItems; // Show all main categories if none selected

        if (activeSubFilter === "all") {
            // Flatten all subcategory products
            return selectedCategory.category.flatMap(cat => cat.subCategory || []);
        }

        // Find selected subcategory
        const subCat = selectedCategory.category.find(
            (c) => c.categoryLink === activeSubFilter
        );
        return subCat?.subCategory || [];
    };

    const displayedProducts = getDisplayedProducts();

    return (
        <>
            <Header />

            {/* Banner */}
            <Box className='Aboutus_topdiv'>
                <img src={polygon} alt="Cleanroom Products" />
                <div className="hosp_aboutushead">
                    <h1>Products</h1>
                </div>
            </Box>

            <Box>
                <div className="celebrity-filtration-div">
                    {/* Left Sidebar */}
                    <div className="leftsidediv col-sm-3">
                        <div className="filterdiv">
                            <h5>Products Filter</h5>
                        </div>

                        {/* Search Box */}
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Products"
                                onChange={handleSearch}
                                value={searchQuery}
                            />
                            <span className="input-group-text"><Search /></span>
                        </div>

                        {/* Category List */}
                        <div className="city-div">
                            <div onClick={() => setIsCategoryOpen(!isCategoryOpen)} className="clickdiv">
                                <h6>All Category</h6>
                                <IoMdArrowDropdown />
                            </div>
                            {isCategoryOpen && (
                                <ul id="categoryList" className="category-list">
                                    <li className={!activeMainCategory ? "active-category" : ""}>
                                        <Link to="/products">All Categories</Link>
                                    </li>
                                    {OurProductData.map((item) => (
                                        <div key={item.linkTag}>
                                            <li className={activeMainCategory === item.linkTag ? "active-category" : ""}>
                                                <Link to={`/products/${item.linkTag}`}>{item.heading}</Link>
                                            </li>
                                        </div>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>

                    {/* Right Content */}
                    <div className="rightsidediv col-sm-9">

                        {/* Subcategory Buttons */}
                        {selectedCategory && (
                            <div className="subcategory-tabs">
                                <Button
                                    variant={activeSubFilter === "all" ? "contained" : "outlined"}
                                    onClick={() => setActiveSubFilter("all")}
                                >
                                    All
                                </Button>
                                {selectedCategory.category.map((subcat) => (
                                    <Button
                                        key={subcat.categoryLink}
                                        variant={activeSubFilter === subcat.categoryLink ? "contained" : "outlined"}
                                        onClick={() => setActiveSubFilter(subcat.categoryLink)}
                                    >
                                        {subcat.categoryName}
                                    </Button>
                                ))}
                            </div>
                        )}

                        {/* Product Cards */}
                        <div className="d-flex flex-wrap justify-content-center">
                            {selectedCategory ? (
                                displayedProducts.slice(0, showCount).map((prod, i) => (
                                    <div key={i} className="card-box">
                                        <div className="card-img-div1">
                                            <img src={prod.categoryImge || prod.imgSrc} alt={prod.categoryName || prod.name} />
                                            <h6>{prod.categoryName || prod.name}</h6>
                                        </div>
                                        <div className="card-content-div">
                                            <Button>
                                                View More<FaSquareArrowUpRight className="iconbtnb" />
                                            </Button>
                                            <Link to={`https://wa.me/918448783350?text=Hi, I'm interested in ${prod.categoryName || prod.name}`}>
                                                <Button className="whatsppbutnnn">
                                                    WhatsApp<WhatsApp className="iconbtnb" />
                                                </Button>
                                            </Link>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                filteredMainItems.slice(0, showCount).map((item) => (
                                    <div key={item.linkTag} className="card-box">
                                        <Link to={`/products/${item.linkTag}`}>
                                            <div className="card-img-div1">
                                                <img src={item.imgSrc} alt={item.heading} />
                                                <h6>{item.heading}</h6>
                                            </div>
                                        </Link>
                                        {/* <div className="card-content-div">
                                            <Link to={`/products/${item.linkTag}`}>
                                                <Button>
                                                    View More<FaSquareArrowUpRight className="iconbtnb" />
                                                </Button>
                                            </Link>
                                            <Link to="https://wa.me/918448783350?text=Hi">
                                                <Button>WhatsApp<WhatsApp className="iconbtnb" /></Button>
                                            </Link>
                                        </div> */}
                                    </div>
                                ))
                            )}
                        </div>

                        {/* Show More / Less */}
                        <div className="btn-div-bottom">
                            {displayedProducts.length > 8 && (
                                <Button variant="contained" onClick={toggleImages}>
                                    {showAll ? "Show Less" : "Show More"}
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </Box>

            <Footer />
        </>
    );
};

export default Products;
